<template>
  <div :class="$style.Page__Layout">
    <p :class="$style.Page__Message" :title="`${error?.message} ${error?.statusCode}`">{{ $t('common.error_page') }}</p>
    <client-only>
      <nuxt-link :class="$style.Page__Btn" to="/">
        <div class="back_home">{{ $t('common.back_home') }}</div>
      </nuxt-link>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

const props = defineProps({
  error: Object as () => NuxtError
});

onMounted(() => {
  if(props.error){
    throw props.error;
  }
});
</script>

<style lang="less" module>
.Page {
  &__Layout {
    display: flex;
    width: 100vw;
    height: 100vh;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    background-image: url('~/assets/img/error_img.png'), url('~/assets/img/error_bg.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 460px, cover;
  }
  &__Message {
    margin-top: 440px;
    max-width: 500px;
    color: #fff;
    font-size: 26px;
    letter-spacing: 1.44px;
    text-align: center;
  }
  &__Btn {
    width: 200px;
    text-align: center;
    border: 1px solid #979797;
    border-radius: 4px;
    color: #fff;
    height: 46px;
    line-height: 46px;
    font-size: 12px;
  }
}
</style>